import { Navigate, useLocation } from 'react-router'
import type { ReactNode } from 'react'
import { useAuth } from '@waago/api'

/** Route guard. Convenience only — the server enforces on every endpoint. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { state } = useAuth()
  const location = useLocation()

  if (state.status === 'loading') {
    return (
      <div
        className="animate-slide-up grid min-h-dvh place-items-center text-sm text-slate-500"
        role="status"
      >
        Chargement…
      </div>
    )
  }
  if (state.status === 'anonymous') {
    // Opening the app cold lands on the welcome screen (frame `4076:2753`) —
    // somebody who has not signed up yet is owed an explanation of what this
    // is before a phone field. A deep link goes straight to the sign-in,
    // because that visitor already knows.
    const target = location.pathname === '/' ? '/bienvenue' : '/connexion'
    return <Navigate to={target} replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
